import RapportsActivitesController from './rapports.activites.controller';
import Template from './rapports.activites.html';
export default {
	controller: RapportsActivitesController,
	template: Template
};
